import React,{useState} from 'react';
import classes from './style.module.css'
import DatePicker from "../UI/DatePicker"
import ToggleButtonDouble from "../UI/ToggleButtonDouble"
import {logInfo} from '../../util/log/logger'
import { passDateToString } from '../../util/date/date-utils'
import { connect } from "react-redux"
//actions imports
import { SET_SELECTION_STATE } from "../../redux/actions"
import { HOME, AWAY, HEADER_CONTROLS, TOTAL } from "../../constants/Constants"
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import Checkbox from '../Checkbox';

const SelectionPanel = props => {
    const [tier, setTier] = useState(["All"]);

    const selectedDateChangeHandler = (event) => {
        logInfo("selectedDateChangeHandler", event)
        const newDate = passDateToString(event);
        console.log(newDate);
        const selectionState = { ...props.selectionState };
        selectionState.selectionDate = newDate;
        console.log(selectionState);
        props.setSelectionState(selectionState)
    }


    const homeStatToggleHandler = () => {
        logInfo(`homeStatToggleHandler. current away stat mode: ${props.selectionState.home}`)
        const newValue = props.selectionState.home === HOME ? TOTAL : HOME
        logInfo(`homeStatToggleHandler. new away stat mode: ${newValue}`)
        const selectionState = {...props.selectionState}
        selectionState.home = newValue
        props.setSelectionState(selectionState)
    }

    const awayStatToggleHandler = () => {
        logInfo(`awayStatToggleHandler. current away stat mode: ${props.selectionState.away}`)
        const newValue = props.selectionState.away === AWAY ? TOTAL : AWAY
        logInfo(`awayStatToggleHandler. new away stat mode: ${newValue}`)
        const selectionState = {...props.selectionState}
        selectionState.away = newValue
        props.setSelectionState(selectionState)
    }

    const handleSelect =  (evt)  => {
        console.log(evt);
        setTier(evt);
        props.updateTier(evt);
     }
    
    const tierChangeHandler =  (value)  => {
       //[Tier 2, true|false]
      if(value[1]){
        var currentTier = tier;
        const index = currentTier.indexOf("All");
        if(index > -1){
            currentTier.splice(index, 1);
        }
        if(currentTier.indexOf(value[0]) < 0){
          currentTier.push(value[0]);
        }
        setTier(currentTier);
        props.updateTier(currentTier);
      }else{
        var currentTier = tier;
        const index = currentTier.indexOf(value[0]);
        if(index > -1){
            currentTier.splice(index, 1);
        }
        setTier(currentTier);
        props.updateTier(currentTier);
      }
   }

   return (
        <div className={classes.MatchSelectionPanel}>
            <Checkbox tierChangeHandler={tierChangeHandler} tier="Top Europe"/>
            <Checkbox tierChangeHandler={tierChangeHandler} tier="Top World"/>
            <Checkbox tierChangeHandler={tierChangeHandler} tier="Tier 2"/>
            <Checkbox tierChangeHandler={tierChangeHandler} tier="Tier 3"/>
            <DatePicker selectedDate={props.selectionState.selectionDate} selectedDateChanged={selectedDateChangeHandler}/>
            <ToggleButtonDouble clicked={homeStatToggleHandler} active={props.selectionState.home === HOME} label0={HEADER_CONTROLS.TOGGLE_HOME_BUTTON.label0} label1={HEADER_CONTROLS.TOGGLE_HOME_BUTTON.label1}/>
            <ToggleButtonDouble clicked={awayStatToggleHandler} active={props.selectionState.away === AWAY} label0={HEADER_CONTROLS.TOGGLE_AWAY_BUTTON.label0} label1={HEADER_CONTROLS.TOGGLE_AWAY_BUTTON.label1} />
        </div>
   );
}

const mapStateToProps = state => {
    return {
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectionPanel);